import { CHAT_VIEW_OPENED_GROUP_ID_LOCALSTORAGE } from '../types';
import { TChatGroupId } from '../../../../../../../../types/rest/IRestChatGroup';

export const getChatOpenedGroupIdLocalStorage = (): TChatGroupId => {
    const data = localStorage.getItem(CHAT_VIEW_OPENED_GROUP_ID_LOCALSTORAGE);
    return data ? JSON.parse(data) : null;
}
